import React, { createContext } from "react";

export type TitleContextApi = {
  setPageTitle: React.Dispatch<React.SetStateAction<string>>;
  setPageIcon: React.Dispatch<React.SetStateAction<string>>;
};
export const PageTitleContext = createContext<TitleContextApi>(null);
